import styled from "styled-components";


export const BtnWhatsApp = styled.button`
  background-color: #24cc63;
  border: none;
  border-radius: 5px;
  width: 85%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
`;

export const BtnWhatsAppInfo = styled.div`
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  margin-left: 10px;
`;